import z from "zod";
import { ObjectPKInput } from "../aws/DynamoDbApiTypes";
import { AbstractOrderLineItem, abstractOrderLineItemSchema  } from "./AbstractOrderLineItem";
import { DynamoKey } from "./BaseDynamoClass";
import { BasicError } from "./BasicError";
import { User, UserPKInput } from "./User";
import { StripUnderscore, UnderscoreKeys } from "../util/Types";

export const cartItemSchema = abstractOrderLineItemSchema.extend({
    _previousUnitPrice : z.string(),
}).refine(obj => !("_unitPrice" in obj));

export type CartItemFields = StripUnderscore<z.infer<typeof cartItemSchema>>;
export class CartItem<TFields extends CartItemFields = CartItemFields> extends AbstractOrderLineItem<TFields> {
    override _className: string = "CartItem";
    override _deserializeClassName: string = "CartItem";
    private _previousUnitPrice! : string;

    constructor(props : Partial<TFields>){
        super(props);
    }
    override getFieldList(): (keyof UnderscoreKeys<TFields>)[] {
        return [...super.getFieldList(), "_previousUnitPrice"];
    }
    override validateSchema(): void {
        cartItemSchema.parse(this);
        super.validateSchema();
    }
	get previousUnitPrice(): string {
		return this.checkFieldType<"previousUnitPrice">(this._previousUnitPrice);
	}
	set previousUnitPrice(value: string) {
		this._previousUnitPrice = this.checkFieldTypeAndMark<"previousUnitPrice">("_previousUnitPrice", value);
	}
    isAvailableToOrder(){
        return !!this.unitPrice;
    }
    hasPriceChanged(){
        return (this.previousUnitPrice && this.previousUnitPrice === this.unitPrice);
    }
    getPKPrefix(): string {
        return "USER#";
    }
    getSKPrefix(props: object | undefined): string {
        return "CARTITEM#";
    }
    getPK(): string {
        return this.getPKPrefix() + this.userId;
    }
	getSK(): string {
		return this.getSKPrefix(this) + this.storyId + this.formatId;
	}
    getParentKey(): DynamoKey | undefined {
        if(!this.userId) throw new BasicError("Missing userId", "Missing userId");
        return User.generateKey({userId: this.userId});
    }
    getParentKeyInput(): ObjectPKInput | undefined {
        if(!this.userId) throw new BasicError("Missing userId", "Missing userId");
        return {userId: this.userId};
    }
    getParentTableName(): string | undefined {
        return undefined;
    }
    generateKey(input: any): DynamoKey {
        if(!input.userId) throw new BasicError("Missing userId", "Missing userId");
        if(!input.storyId || !input.formatId) throw new BasicError("Missing storyId or format Id", "Missing storyId or format Id");
        return {
            PK: this.getPKPrefix + input.userId,
            SK: this.getSKPrefix(input) + input.storyId + input.formatId
        }
    }
    generatePK(input: UserPKInput): string {
        if(!input.userId) throw new BasicError("Missing userId", "Missing userId");
        return this.getPKPrefix() + input.userId;
    }
    generateGSIPK(index: number, key: object): string {
        throw new Error("Method not implemented.");
    }
    generateGSISK(index: number, key: object | undefined): string {
        throw new Error("Method not implemented.");
    }
    getIgnoreFields(): string[] {
        return super.getIgnoreFields();
    }
    getGlobalIndices(): object {
        return {};
    }
    getColumnsForExport(): string[] {
        throw new Error("Method not implemented.");
    }
    getObjectForExport(): object {
        throw new Error("Method not implemented.");
    }
}